import config from '../../../configuration/configuration.js';
import AxiosRequest from '../../../utils/AxiosRequest';

export const GetRequestsList = () => 
	AxiosRequest({
		method: 'GET',
		url: `${config.API_URL}LockdownAggregation/GetRequestsList`
	});

export const DeleteRequest = (userId, name) =>
	AxiosRequest({
		method: 'POST',
		url: `${config.API_URL}LockdownAggregation/DeleteRequest`,
		data: { name, userId }, // Passa o nome do request a ser excluído
	});

export const CreateRequest = (dto) =>
	AxiosRequest({
		method: 'POST',
		url: `${config.API_URL}LockdownAggregation/Upload`,
		data: dto, /// Passa o objecto do request para ser criado
	});